<template>
  <hb-section :title="$t('influencer_panel.funnel')" :subtitle="$t('influencer_panel.funnel_hint')">
    <div class="funnel">
      <div v-for="(step, index) in steps" :key="step.key" class="funnel__step">
        <div class="funnel__row">
          <span class="funnel__label">{{ $t(`influencer_panel.funnel_${step.key}`) }}</span>
          <span class="funnel__value">{{ step.count.toLocaleString('pt-BR') }}</span>
        </div>
        <div class="funnel__bar">
          <div class="funnel__bar-fill" :style="{ width: `${widthOf(step)}%` }" />
        </div>
        <div v-if="index > 0" class="funnel__delta" :class="{ 'funnel__delta--worst': step.key === worstStepKey }">
          {{ $t('influencer_panel.funnel_from_previous', { pct: retentionOf(index) }) }}
          <template v-if="step.key === worstStepKey">— {{ $t('influencer_panel.funnel_biggest_drop') }}</template>
        </div>
      </div>
    </div>

    <!-- Os dois passos do meio só existem quando o comprador aceitou cookies de
         desempenho. Sem essa ressalva, o influencer leria a queda como perda de venda. -->
    <p class="funnel__note">
      <feather-icon icon="InfoIcon" size="13" />
      {{ $t('influencer_panel.funnel_consent_note') }}
    </p>
  </hb-section>
</template>

<script>
import HbSection from '@/components/hubee/HbSection.vue'

/**
 * Do clique até a venda.
 *
 * O passo do meio é "Navegou no marketplace", nao "Vitrine visitada": nao existe pagina
 * de vitrine ainda, entao o rotulo diz o que realmente foi medido.
 */
export default {
  name: 'ConversionFunnel',
  components: { HbSection },
  props: {
    steps: { type: Array, default: () => [] },
  },
  computed: {
    topCount() {
      return Math.max(1, Number((this.steps[0] || {}).count || 0))
    },
    /**
     * O passo com a menor retenção contra o anterior. Ignora passos zerados: um passo
     * sem medição alguma não é a "maior perda", é ausência de dado.
     */
    worstStepKey() {
      let worst = null
      let worstRate = Infinity

      this.steps.forEach((step, index) => {
        if (index === 0) return
        const previous = Number(this.steps[index - 1].count || 0)
        const current = Number(step.count || 0)
        if (previous <= 0 || current <= 0) return

        const rate = current / previous
        if (rate < worstRate) {
          worstRate = rate
          worst = step.key
        }
      })

      return worst
    },
  },
  methods: {
    widthOf(step) {
      return Math.max(2, Math.round((Number(step.count || 0) / this.topCount) * 100))
    },
    retentionOf(index) {
      const previous = Number(this.steps[index - 1].count || 0)
      const current = Number(this.steps[index].count || 0)

      return previous > 0 ? Math.round((current / previous) * 100) : 0
    },
  },
}
</script>

<style scoped>
.funnel {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}

.funnel__row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
}

.funnel__label {
  font-size: var(--fs-sm);
  color: var(--text-body);
}

.funnel__value {
  font-weight: var(--fw-medium);
  color: var(--text-heading);
}

.funnel__bar {
  height: 10px;
  border-radius: var(--radius-pill);
  background: var(--surface-sunken);
  overflow: hidden;
}

.funnel__bar-fill {
  height: 100%;
  border-radius: var(--radius-pill);
  background: var(--primary);
}

.funnel__delta {
  margin-top: 0.3rem;
  font-size: var(--fs-xs);
  color: var(--text-muted);
}

.funnel__delta--worst {
  color: var(--warning);
  font-weight: var(--fw-medium);
}

.funnel__note {
  margin: 1.1rem 0 0;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: var(--fs-xs);
  color: var(--text-muted);
}
</style>
